import React from 'react';
import { Flex, Box, BoxProps, Stack, SystemStyleObject } from '@chakra-ui/react';
import { faArrowFromLeft, faArrowToLeft } from '@fortawesome/pro-regular-svg-icons';
import { IconButtonWithTooltip } from '../molecules/IconButtonWithTooltip';

interface ISidebarCollapse {
  children?: React.ReactNode;
  containerProps?: BoxProps;
  label?: string;
  isOpen?: boolean;
  onToggle?: () => void;
}

export const SidebarCollapse = (props: ISidebarCollapse): React.ReactElement => {
  const { children, containerProps, label, isOpen, onToggle } = props;

  const expandedStyles: SystemStyleObject = {
    width: 'sidebarWidth',

    '.sidebar-inner': {
      opacity: 1,
      pointerEvents: 'initial',
    },
  };

  return (
    <Stack
      display={{ base: 'none', md: 'flex' }}
      position={'relative'}
      width={isOpen ? 'sidebarWidth' : 'sidebarCollapse'}
      transition={'ease-out 0.3s width'}
      {...containerProps}
    >
      <Flex
        as="nav"
        id="sidenav"
        aria-label={label}
        className="sidebar-outer"
        bgColor="chakra-subtle-bg"
        borderRightWidth="1px"
        flexDirection="column"
        flexShrink={0}
        flexGrow={1}
        height={'100%'}
        overflow={'hidden'}
        width={isOpen ? 'sidebarWidth' : 'sidebarCollapse'}
        zIndex={100}
        position={'relative'}
        transition={'ease-out 0.3s width'}
        _hover={expandedStyles}
        _focusWithin={expandedStyles}
      >
        <Box
          className="sidebar-inner"
          opacity={isOpen ? 1 : 0}
          overflow="hidden"
          transition={'ease-out 0.3s opacity'}
          pointerEvents={!isOpen ? 'none' : undefined}
        >
          <Flex flexDirection={'column'} minWidth={'sidebarWidth'} height={'100%'} overflowY={'hidden'}>
            {children}
          </Flex>
        </Box>
      </Flex>

      <Box className="sidebar-collapse" position={'absolute'} bottom={2} right={-5} zIndex={500} p={1} pb={1}>
        <IconButtonWithTooltip
          label={isOpen ? 'Collapse menu' : 'Expand menu'}
          iconProps={{ icon: isOpen ? faArrowToLeft : faArrowFromLeft }}
          buttonProps={{
            'aria-controls': 'sidenav',
            'aria-expanded': isOpen ? 'true' : 'false',
            size: 'sm',
            variant: 'outline',
            colorScheme: 'gray',
            isRound: true,
            bgColor: 'chakra-subtle-bg',
            borderColor: 'chakra-border-color',
            _hover: {
              bgColor: 'gray.100',
              borderColor: 'gray.200',
              _dark: {
                bgColor: 'gray.700',
              },
            },
            _active: {
              bgColor: 'gray.200',
              borderColor: 'gray.300',
              _dark: {
                bgColor: 'gray.600',
              },
            },
          }}
          tooltipProps={{ placement: 'right' }}
          onClick={onToggle || ((): void => {})}
        />
      </Box>
    </Stack>
  );
};
